// VIDEO LAZYLOAD
document.addEventListener("DOMContentLoaded", function () {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (
              typeof videoSource.tagName === "string" &&
              videoSource.tagName === "SOURCE"
            ) {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function (lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});

$(document).ready(function () {
  $('[data-open-sidebar]').on('click', function () {
    $('.page-sidebar, .page-content').toggleClass('sidebar-open');
    $(this).find('.text').text($('.page-sidebar').hasClass('sidebar-open') ? 'Ocultar Filtros' : 'Mostrar Filtros');
  });
});

(function () {
  if (window.haloBuildYtFacade) return;

  function buildYtFacade(facade) {
    if (!facade || facade.dataset.ytLoaded) return;
    var id = facade.dataset.videoId;
    if (!id) return;
    facade.dataset.ytLoaded = "1";

    var controls = facade.dataset.controls === "0" ? "&controls=0" : "";
    var iframe = document.createElement("iframe");
    iframe.id = facade.dataset.playerId;
    iframe.className = facade.dataset.playerClass;
    iframe.width = "100%";
    iframe.height = "100%";
    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute("allow", "autoplay; encrypted-media; fullscreen");
    iframe.setAttribute("allowfullscreen", "");
    iframe.setAttribute("data-video-id", id);
    iframe.src =
      "https://www.youtube.com/embed/" + id +
      "?enablejsapi=1&rel=0&autoplay=1&mute=1&loop=1&playlist=" + id + controls;

    facade.replaceWith(iframe);
  }

  window.haloBuildYtFacade = buildYtFacade;

  function initYtFacades() {
    document.addEventListener("click", function (e) {
      var facade = e.target.closest && e.target.closest("[data-yt-facade]");
      if (facade) buildYtFacade(facade);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Enter" && e.key !== " ") return;
      var facade = e.target.closest && e.target.closest("[data-yt-facade]");
      if (facade) {
        e.preventDefault();
        buildYtFacade(facade);
      }
    });

    var facades = [].slice.call(document.querySelectorAll("[data-yt-facade][data-autoplay='1']"));
    if (!facades.length) return;

    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              buildYtFacade(entry.target);
              obs.unobserve(entry.target);
            }
          });
        },
        { rootMargin: "200px 0px" }
      );
      facades.forEach(function (facade) {
        io.observe(facade);
      });
    } else {
      facades.forEach(buildYtFacade);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initYtFacades);
  } else {
    initYtFacades();
  }
})();